import { GridTransaction } from "fe-shared-transactions/src/types";
import { FileInterface } from "fe-shared/src/types/common";

export interface GridTransactionInternal extends GridTransaction {
  hasAutoFlag: boolean;
  hasManualFlag: boolean;
  hasNotLinkedFlag: boolean;
  assigneeId: number | null;
  assigneeDisplayName: string;
  submittedByDisplayName: string;
  initiatedDate: string;
  syncedDate: string;
}

export enum TransactionAction {
  Invalidate = "Invalidate",
  Restore = "Restore",
  Return = "Return",
  Approve = "Approve",
  CreateAdjustment = "CreateAdjustment",
  EditAdjustment = "EditAdjustment",
  ApproveAdjustment = "ApproveAdjustment",
  EditDisposition = "EditDisposition",
}

interface Content {
  [key: string]: unknown;
}

export interface RetreadingTransactionFormContent extends Content {
  attachments: FileInterface[];
  companyId: number | null;
  companyName: string | null;
  comment: string;
  isKnownRetreaderTiresActualWeight: boolean;
  productionReportDate: string | null;
  periodYear: number;
  periodMonth: string;
  collectionInfoMaterials: Record<string, number>;
  retreadRepairInfoMaterials: Record<string, number>;
  recoveryInfoMaterials: Record<string, number | undefined>;
}
